module.exports = __webpack_public_path__ + "img/pdf-icon.50434788.png";